import { Box, Typography } from "@mui/material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

export default function EmptyState({ title, text, icon, action }) {
  return (
    <Box sx={{ py: 6, px: 2, textAlign: "center", color: "text.secondary" }}>
      <Box sx={{ fontSize: 40, lineHeight: 0, mb: 1.5, color: "#A9B4BC" }}>
        {icon || <InboxOutlinedIcon fontSize="inherit" />}
      </Box>
      <Typography variant="subtitle1" color="text.primary">
        {title}
      </Typography>
      {text && (
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          {text}
        </Typography>
      )}
      {action && <Box sx={{ mt: 2 }}>{action}</Box>}
    </Box>
  );
}
